import { render } from "./themify_icon.vue?vue&type=template&id=45d1d416&scoped=true"
import script from "./themify_icon.vue?vue&type=script&lang=js"
export * from "./themify_icon.vue?vue&type=script&lang=js"

import "./themify_icon.vue?vue&type=style&index=0&id=45d1d416&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d1d416"]])

export default __exports__